import React, { createContext, useState, useContext } from "react";

const CodingLanguagesContext = createContext();

function CodingLanguagesProvider({ children }) {
  const [selectedLanguage, setSelectedLanguage] = useState("");
  const [code, setCode] = useState("");

  const handleChange = (event) => {
    setSelectedLanguage(event.target.value);
  };

  const handleEditorChange = (value, event) => {
    setCode(value);
  };

  return (
    <CodingLanguagesContext.Provider
      value={{ selectedLanguage, handleChange, setSelectedLanguage,handleEditorChange,setCode,code }}
    >
      {children}
    </CodingLanguagesContext.Provider>
  );
}

const useCodingLanguages = () => {
  return useContext(CodingLanguagesContext);
};

export { useCodingLanguages };
export default CodingLanguagesProvider;
